// extracted by mini-css-extract-plugin
module.exports = {"styledCheckBox":"vhcZGHL7"};